module.exports = __webpack_public_path__ + "static/img/1.f6c534e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/14/1.png
// module id = OE+P
// module chunks = 0